export var ApplicationLinkingColor;
(function (ApplicationLinkingColor) {
    ApplicationLinkingColor[ApplicationLinkingColor["Yellow"] = 0] = "Yellow";
    ApplicationLinkingColor[ApplicationLinkingColor["Red"] = 1] = "Red";
    ApplicationLinkingColor[ApplicationLinkingColor["Green"] = 2] = "Green";
    ApplicationLinkingColor[ApplicationLinkingColor["Orange"] = 3] = "Orange";
    ApplicationLinkingColor[ApplicationLinkingColor["Blue"] = 4] = "Blue";
    ApplicationLinkingColor[ApplicationLinkingColor["Purple"] = 5] = "Purple";
})(ApplicationLinkingColor || (ApplicationLinkingColor = {}));
